import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  IAppErrorFactory,
  IArticlesService,
  IUpdateMyArticleUseCase,
  UpdateMyArticleUseCaseInput,
  UpdateMyArticleUseCaseOutput,
} from '../../types'

@injectable()
export default class UpdateMyArticleInteractor implements IUpdateMyArticleUseCase {
  @inject(symbols.IArticlesService) private articlesService: IArticlesService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: UpdateMyArticleUseCaseInput): Promise<UpdateMyArticleUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.article = await this.articlesService.updateMyArticle(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): UpdateMyArticleUseCaseOutput {
    return {
      article: null,
      error: null,
    }
  }
}
